import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setActiveTab } from '../redux/slice/activeTabSlice';
import { selectSelectedLeague } from '../redux/slice/selectedLeagueSlice';
import Home from '../views/leaguesHome/home/Home';
import Tournaments from '../views/leaguesHome/tournaments/Tournaments';
import Teams from '../views/leaguesHome/teams/Teams';
import About from '../views/leaguesHome/about/About';
import Request from '../views/leaguesHome/request/Request';
import Gallery from '../views/leaguesHome/gallery/Gallery';
import Squads from '../views/leaguesHome/squads/Squads';
import Grounds from '../views/leaguesHome/ground/Grounds';
import Documents from '../views/leaguesHome/documents/Documents';
import { getAuthToken } from '../helper/helper';

const TabContentWrapper: React.FC = () => {
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((s) => s?.activeTab?.value);
  const selectedLeague = useAppSelector(selectSelectedLeague);
  const canAccessRequests =
    Boolean(getAuthToken()) && Boolean(selectedLeague?.canEditLeague);

  useEffect(() => {
    if (activeTab === 'requests' && !canAccessRequests) {
      dispatch(setActiveTab('home'));
      sessionStorage.setItem('activeTab', 'home');
    }
  }, [activeTab, canAccessRequests, dispatch]);

  // Render content based on active tab, default to home if no tab is selected
  switch (activeTab) {
    case 'home':
    case 'leagues-home':
      return <Home />;
    case 'tournaments':
      return <Tournaments />;
    case 'teams':
      return <Teams />;
    case 'gallery':
      return <Gallery />;
    case 'about':
      return <About />;
    case 'squads':
      return <Squads />;
    case 'documents':
      return <Documents />;
    case 'grounds':
      return <Grounds />;
    case 'requests':
      return canAccessRequests ? <Request /> : <Home />;
    default:
      return <Home />;
  }
};

export default TabContentWrapper;
